var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOffOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24994 12.55C8.83784 12.6279 8.41934 12.667 7.99994 12.6667C5.01461 12.6667 2.48794 10.7047 1.63794 8C1.86678 7.27207 2.21927 6.58898 2.67994 5.98067M9.41327 9.41333L6.58527 6.586C6.96038 6.2109 7.46913 6.00016 7.99961 6.00016C8.53008 6.00016 9.03884 6.2109 9.41394 6.586C9.78904 6.9611 9.99978 7.46986 9.99978 8.00033C9.99978 8.53081 9.78904 9.03956 9.41394 9.41467L11.6079 11.608M6.58661 6.58667L4.39327 4.39333M4.39327 4.39333L1.99994 2M4.39327 4.39333C5.46818 3.69971 6.72067 3.3316 7.99994 3.33333C10.9853 3.33333 13.5119 5.29533 14.3619 8C13.8926 9.48697 12.9182 10.763 11.6073 11.6073L13.9999 14",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOffOutline);
export default __webpack_public_path__ + "static/media/EyeOffOutline.ac83576d6bddc4b52a8bab1a893bc8d8.svg";
export { ForwardRef as ReactComponent };